module.exports = __webpack_public_path__ + "img/search.8cf0f5f9.svg";